import { useFormikContext } from "formik";
import React, { FC, useContext, useEffect, useState } from "react";

import removeSocialNetworkInput from "../../../assets/minusIcon.svg";
import { EMPTY_STRING } from "../../../common/constants/common.constants";
import { ICreateClubWizardForm } from "../../../common/interfaces/clubs-wizard.interface";
import { IUserSettingsFormFields } from "../../../common/interfaces/user.interface";
import { UserContext } from "../../../contexts/userContext";
import WizardField from "../../WizardField/WizardField";
import "./SocialNetworks.scss";

export interface IBasicInfoProps {
  socialNetworks: Array<{
    network: {
      name: string;
      label: string;
      initialValue: string;
      placeholder?: string;
    };
    active: boolean;
  }>;
  createClubForm?: boolean;
  canAddLater?: boolean;
}

const SocialNetworks: FC<IBasicInfoProps> = ({
  socialNetworks,
  createClubForm,
  canAddLater,
}) => {
  const { setFieldValue, values } = useFormikContext<
    IUserSettingsFormFields | ICreateClubWizardForm
  >();
  const { user } = useContext(UserContext);
  const [socialNetworksWithStatus, setSocialNetworksWithStatus] = useState<
    Array<{
      network: {
        name: string;
        label: string;
        initialValue: string;
        placeholder?: string;
      };
      active: boolean;
    }>
  >(socialNetworks);

  useEffect(() => {
    if (!createClubForm && user) {
      setFieldValue("discord", user.discord);
      setFieldValue("twitter", user.twitter);
      setFieldValue("instagram", user.instagram);
      setFieldValue("linkedin", user.linkedin);
      setFieldValue("tiktok", user.tiktok);
      setFieldValue("telegram", user.telegram);
      setFieldValue("reddit", user.reddit);
    }
  }, []);

  //TODO@milica: update in next sprint
  const updateNetworkStatus = (networkItem, status) => {
    let networks = [...socialNetworksWithStatus];
    let index = socialNetworksWithStatus.findIndex(
      (item) => item.network.name === networkItem.network.name
    );
    networks[index] = {
      network: networks[index].network,
      active: status,
    };
    if (!status) {
      setFieldValue(networkItem.network.name, EMPTY_STRING);
    }
    setSocialNetworksWithStatus(networks);
  };

  return (
    <div className="social-networks">
      <p className="social-networks__label">
        Social networks {canAddLater && <span>You can add this later</span>}
      </p>
      <div className="social-networks__inputs">
        {socialNetworksWithStatus
          .filter(
            (item) => item.active || values[item.network.name] !== EMPTY_STRING
          )
          .map((item) => (
            <div
              className={`social-networks__input ${item.network.name}`}
              key={item.network.name}
            >
              <WizardField
                type="text"
                name={item.network.name}
                placeholder={`${item.network.placeholder}`}
              />
              {item.network.name !== "discord" && (
                <img
                  onClick={() => updateNetworkStatus(item, false)}
                  src={removeSocialNetworkInput}
                  alt="removeImg"
                />
              )}
            </div>
          ))}
      </div>
      <div className="social-networks__buttons">
        {socialNetworksWithStatus
          .filter(
            (item) => !item.active && values[item.network.name] === EMPTY_STRING
          )
          .map((item) => (
            <button
              key={item.network.name}
              type="button"
              onClick={() => updateNetworkStatus(item, true)}
            >
              {item.network.label}
              <span>+</span>
            </button>
          ))}
      </div>
    </div>
  );
};

export default SocialNetworks;
